<template>
    <div>  

        <!-- //-----------------payment summary------------- -->
        <v-dialog
            v-model="dialog_payment_summary"
            scrollable   
            :persistent="false" :overlay="false"
            max-width="1250px"
            transition="dialog-transition" >
            <v-card rounded="lg"  > 
                <v-toolbar style="--px:-18px;" dark class="mbs-pull-x- primary  px-4" 
                    flat color="transparent" >
                    <v-layout align-center> 
                        <div class="font-weight-bold    text--darken-2 ml-">
                            <span v-if="selected_card_option=='load_money'">Card Load Money</span>
                            <span v-if="selected_card_option=='pay'">Card Payment</span>
                            <span v-else>Payment</span>
                        </div> 
                        <v-spacer></v-spacer>
                        <!-- <v-btn outlined>Pay</v-btn> -->
                        <v-btn icon @click="dialog_payment_summary=false">
                            <v-icon  >close</v-icon>
                        </v-btn>
                    </v-layout> 
                </v-toolbar>   
                <v-layout row wrap  class="ma-0 b1">
                    <v-flex xs12 sm12 md5 v-if="!vs.smAndDown" class="">  
                        <mbs-sale-payments-summary 
                            class="mx-4 mt-4"
                            :height="vsh-215"
                            :outlined="true"
                            :selected_items="selected_items"
                            :TotalPrice="TotalPrice"
                            :CalculatedVAT="CalculatedVAT"
                            :CALCULATE_PRICE="CALCULATE_PRICE"
                            :PriceExcludeVAT="PriceExcludeVAT"
                        />
                         
                    </v-flex>
                    <v-flex xs12 sm12 md7 class="py-0 ma-0">
                        <v-card height="100%" class="pt-5"  rounded="sm" flat> 
                            <v-card rounded="sm" class="primary mx-4 px-5 py-2" dark>
                                <v-layout  align-center>
                                    
                                    <div v-if="!vs.xs" class="font-weight-bold not-f5 mr-4 ">TOTAL TO PAY</div>
                                    <div class="font-weight-bold not-f9">
                                        {{selected_card_option=='load_money'?MBS.actions.money(pay_order.card_load_amount): MBS.actions.money(TotalDiscountedPrice)}}
                                    </div>
                                </v-layout> 
                            </v-card>
                            <v-card-text>
                                <form @submit.prevent="VERIFY_SUBMIT_ORDER(pay_order,'on_account')">
                                    <v-layout align-center justify-center class="pb-5 pt-2">
                                        
                                        <v-btn 
                                            @click="ON_PAY()"
                                            :loading="inputLoading"
                                            color="secondary" class="mr-3" 
                                            :min-width="vs.smAndDown?'180':'200'" :height="vs.smAndDown?'45':'50'" 
                                            :large="!vs.smAndDown"  
                                            :small="vs.smAndDown"  
                                            >
                                            <div class="not-f6">Pay</div>
                                        </v-btn> 
                                        <v-btn @click="VERIFY_SUBMIT_ORDER(pay_order,'card_payment')"   
                                            v-if="selected_card_option=='pay'"    color="secondary" class="my-5" 
                                                min-width="200" height="50"  > 
                                            <v-icon>mdi-credit-card-outline</v-icon>
                                            <span class="pl-2">Pay</span>
                                        </v-btn>   
                                        <v-menu v-if="MBS.actions.SIZE(PaymentMethodsData)>0"
                                            v-model="menuPaymentOptions" 
                                            :close-on-content-click="false" 
                                            offset-y  offset-overflow
                                            :nudge-width="90" rounded="xl"
                                            >
                                            <template v-slot:activator="{ on }">  
                                                <v-btn v-on="on"  
                                                    :loading="inputLoading"
                                                    color="primary" class="mr-1" 
                                                    :min-width="vs.smAndDown?'180':'200'" :height="vs.smAndDown?'45':'50'" 
                                                    :large="!vs.smAndDown"  
                                                    :small="vs.smAndDown"  
                                                    >
                                                    <div class="not-f6">Pay Options</div> 
                                                    <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                                </v-btn>
                                            </template> 
            
                                            <v-card>
                                                <v-card-title primary-title class="secondary white--text"  >
                                                    Select Payment Option
                                                </v-card-title>
                                                <v-list>
                                                    <v-list-item v-for="(payment_option, index) in [{code:'cash',key:'cash',name:'CASH'},
                                                            ...PaymentMethodsData
                                                        ]" :key="index" @click="SELECT_PAYMENT_OPTION(payment_option)">
                                                        {{payment_option.name}}
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-menu>   
                                        
                                    </v-layout>
                                    
                                    <v-card outlined :height="vs.xs?vsh-670:vsh-470" class=" mbs-scroll-y"> 
                                        <v-card-text> 
                                            <mbs-input-fields  
                                                v-model="input"
                                                :field_items="DATA.FIELDS.sale_on_account"
                                                :select_items="DataSource" 
                                                :disabled_fields="DisabledOnAccountFields" 
                                                px="1" py="1"
                                                /> 
                                        </v-card-text>
                                    </v-card>
                                    <v-layout row wrap class="mt-5">
                                        <v-col v-if="!vs.xs"  cols="12" sm="4" >
                                            <v-btn disabled large color="secondary darken-2" width="100%">Layby</v-btn>
                                        </v-col>
                                        <v-col v-if="!vs.xs"  cols="12" sm="4" class="px-0">
                                            <v-btn :disabled="item_order?.order_type == 'quotation'"  type="submit" @click="created_document_type='quotation'" large color="secondary darken-4" width="100%">Create Quotation</v-btn>
                                        </v-col>
                                        <v-col cols="12" sm="4" >
                                            <v-btn type="submit" @click="created_document_type='invoice'"  large color="secondary darken-2" width="100%">On Account (Invoice)</v-btn>
                                        </v-col>
                                    </v-layout> 
                                </form>
                            </v-card-text> 
                        </v-card> 
                    </v-flex> 
                </v-layout>
            </v-card> 
        </v-dialog>  
        
        <!-- //-------------------pay options--------- -->
        <v-dialog
            v-model="dialog_payment_options"
            scrollable   
            :persistent="false" :overlay="false"
            max-width="950px"
            transition="dialog-transition" >
            <v-card rounded="lg"  > 
                <v-layout fill-height column class="ma-0"> 
                    <v-hover v-slot="{ hover }">
                        <v-card style="--px:-18px;" class="mbs-pull-x" 
                            flat color="transparent" @click="BACK_TO_SALE()">
                            <v-layout align-center>
                                <v-btn icon><v-icon :color="hover?'secondary':''">mdi-arrow-left-bold </v-icon></v-btn>
                                <div class="font-weight-bold not-f8 grey--text text--darken-2 ml-">
                                    <span v-if="selected_card_option=='load_money'">Card Load Money</span>
                                    <span v-if="selected_card_option=='pay'">Card Payment</span>
                                    <span v-else>Sale</span>
                                </div> 
                            </v-layout> 
                        </v-card>   
                    </v-hover>
                    <v-divider v-if="false"></v-divider>

                    <!-- //IF SELECTED CARD -->
                    <v-layout v-if="selected_card" column   align-center justify-center >
                        <v-card class=" px-5 py-2 mt-9 mr-3" outlined>
                            <div class="text-center font-weight-bold grey--text text--darken-2 not-f5 pt-2">{{selected_card.customer_name}}</div>
                            <v-list class="pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-avatar
                                            size="60"
                                            color="b2" >
                                            <v-avatar
                                                size="35"  tile> 
                                            <v-icon>{{mdiAccountCreditCard}}</v-icon>
                                            </v-avatar>
                                        </v-avatar>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Type:{{selected_card.card_type_name}}</v-list-item-subtitle> 
                                        <v-list-item-subtitle>No.: {{selected_card.code}}</v-list-item-subtitle> 
                                        <v-list-item-subtitle>Exp.: {{selected_card.card_expire_date}}</v-list-item-subtitle> 
                                        <v-list-item-subtitle>Bal.: {{selected_card.balance_amount_}}</v-list-item-subtitle> 

                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card> 

                        <!-- //LOAD MONEY -->
                        <v-list color="transparent" v-if="selected_card_option == 'load_money'">
                            <template>
                                <v-list-item  >
                                    <template >  
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Card Current Balance
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                Balance
                                            </v-list-item-subtitle> 
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            {{MBS.actions.money(selected_card.balance_amount)}} 
                                        </v-list-item-action>   
                                    </template> 
                                </v-list-item>
                            </template>
                            <v-divider class="mx-3 mt-5" ></v-divider>  
                            <v-list-item  dense   >
                                <v-list-item-content >
                                    <div>Total After Load</div>
                                    <div>Tax</div> 
                                </v-list-item-content>
                                <v-list-item-action>
                                    <div>MWK {{MBS.actions.money(toNumber(selected_card.balance_amount)+toNumber(pay_order.card_load_amount))}}</div>
                                    <div>MWK 0.00</div>
                                </v-list-item-action>   
                            </v-list-item>
                            
                            <v-divider class="mx-3"></v-divider>
                            <v-list-item     class="grey--text text--darken-2" >
                                <v-list-item-content>
                                    <v-layout class="ma-0 " align-center>
                                        <div class="font-weight-bold not-f6">TOTAL LOAD CASH</div> 
                                    </v-layout>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-layout class="ma-0" align-center>
                                        <div class="font-weight-bold not-f3 pt-1 ">MWK </div>
                                        <div class="font-weight-bold not-f6">{{MBS.actions.money(pay_order.card_load_amount)}}</div>
                                    </v-layout> 
                                </v-list-item-action>   
                            </v-list-item>
                            <v-divider class="mx-3"></v-divider>
                        </v-list>
                        <v-spacer></v-spacer>
                    </v-layout>

                    
                    <v-card  v-if="selected_items && selected_card_option !='load_money'" :height="'100%'" 
                    color="transparent" class="  pl- pr-4" flat target="">
                        <v-simple-table class="b1 ml-3" :height="vsh_payment_sam_table" fixed-header dense>
                            <template v-slot:default>
                                <thead>
                                    <tr class="font-weight-bold ">
                                        <th class=" text-left "> 
                                        </th>
                                        <th class=" text-left ">
                                            ITEM
                                        </th>
                                        <th class="text-center "> 
                                            <span  > 
                                                PRICE
                                            </span>
                                        </th>
                                        <th class="text-center ">
                                            QTY
                                        </th> 
                                        <th class="text-center ">
                                            TOTAL <span v-if="CalculatedVAT?CalculatedVAT.total_vat:false">(EX VAT)</span>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item,index) in selected_items"
                                        :key="item.key" >
                                        <td class="pl- text- with-divider-lr table-background1">{{ index+1 }}</td>
                                        <td class="pl- text- with-divider">{{ item.name }}</td>
                                        <td class=" text-right with-divider"> 
                                            <span  > 
                                                {{ item.sold_price }}
                                            </span>
                                        </td> 
                                        <td class=" text-center with-divider">{{ item.quantity }}</td> 
                                        <td class=" text-right with-divider">{{MBS.actions.money(PriceExcludeVAT(CALCULATE_PRICE(item),item.tax_group_code))}} </td>
                                        <td class=" text-right with-divider" style="width:40px;" >{{
                                            item.tax_group_code?item.tax_group_code:"A"
                                        }}</td>
                                    </tr>
                                    <!-- <v-divider class="mx-3"></v-divider> -->
                                </tbody>
                            </template>
                        </v-simple-table>
                        <!-- <v-divider class="mx-3"></v-divider> -->
                        <v-list color="transparent" >
                            <template>
                                <v-list-item   v-if="false" 
                                    :key="index"  v-for="(item, index) in selected_items">
                                    <template >  
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                 {{item.name}}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                 {{item.pricing_tier}}: {{item.quantity}} X {{item.sold_price}}
                                            </v-list-item-subtitle> 
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            {{MBS.actions.money(CALCULATE_PRICE(item))}} 
                                        </v-list-item-action>   
                                    </template> 
                                </v-list-item>
                            </template>

                            <!-- //show discount -->
                            <div v-if="TotalDiscount||(CompanySettings?CompanySettings.calculate_vat:false)">
                                <v-divider class="mx-3 mt-" ></v-divider>  
                                <v-list-item  dense   >
                                    <v-list-item-content >
                                        <div class="not-f2 font-weight-bold">SUB-TOTAL</div>
                                        <div v-if="TotalDiscount" class="not-f2 font-weight-bold">DISCOUNT</div> 
                                        
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <div class="not-f2 font-weight-bold">
                                            <span v-if="CalculatedVAT">
                                                <span v-if="CalculatedVAT.vat_exclusive">{{MBS.actions.money(toNumber(TotalPrice))}}</span>
                                                <span v-else>{{MBS.actions.money(toNumber(TotalPrice)-toNumber(CalculatedVAT.total_vat))}}</span> 
                                            </span>
                                            <span v-else>{{MBS.actions.money(TotalPrice)}}</span>
                                        </div>
                                        <div v-if="TotalDiscount" class="not-f2 font-weight-bold">{{MBS.actions.money(TotalDiscount)}}</div>  
                                    </v-list-item-action>   
                                </v-list-item> 
                            </div>
                            
                            <!-- //show VAT -->
                            <div v-if="CompanySettings?CompanySettings.calculate_vat:false">
                                <v-divider class="mx-3 mb-2" ></v-divider>
                                <span class="grey--text text--darken-2 " v-if="CalculatedVAT" > 
                                    <span v-if="CalculatedVAT.taxable_a" >
                                        <v-layout class="mx-3 ">
                                            <div class="not-f2 font-weight-bold">TAXABLE A-17.5%</div>
                                            <v-spacer/>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_a)}}</div>
                                        </v-layout> 
                                        <v-layout class="mx-3">
                                            <div class="not-f2 font-weight-bold">VAT A-17.5%</div>
                                            <v-spacer/>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_a)}}</div>
                                        </v-layout>   
                                    </span>
                                    
                                    <span v-if="CalculatedVAT.taxable_b">
                                        <v-layout class="mx-3">
                                            <div class="not-f2 font-weight-bold">TAXABLE B-0%</div>
                                            <v-spacer/>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_b)}}</div>
                                        </v-layout> 
                                        <v-layout class="mx-3">
                                            <div class="not-f2 font-weight-bold">VAT B-0%</div>
                                            <v-spacer/>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_b)}}</div>
                                        </v-layout>   
                                    </span>
                                    
                                    <span v-if="CalculatedVAT.taxable_c">
                                        <v-layout class="mx-3">
                                            <div class="not-f2 font-weight-bold">TAXABLE E-0%</div>
                                            <v-spacer/>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_c)}}</div>
                                        </v-layout> 
                                        <v-layout class="mx-3">
                                            <div class="not-f2 font-weight-bold">VAT E-0%</div>
                                            <v-spacer/>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_c)}}</div>
                                        </v-layout> 
                                    </span>

                                    <v-layout class="mx-3 mt-2 mb-2 grey--text text--darken-3">
                                        <div class="not-f3 font-weight-bold">TOTAL VAT</div>
                                        <v-spacer/>
                                        <div class="not-f3 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.total_vat)}}</div>
                                    </v-layout>   
                                </span>

                                <v-list-item  dense  class="grey--text text--darken-2" v-if="false" >
                                    <v-list-item-content >
                                        <span class='mb-2'>
                                            <div class="not-f2 font-weight-bold">TAXABLE A-17.5%</div>
                                            <div class="not-f2 font-weight-bold">VAT A-17.5%</div>  
                                        </span>
                                        <span class='mb-2'>
                                            <div class="not-f2 font-weight-bold">TAXABLE B-0%</div> 
                                            <div class="not-f2 font-weight-bold">VAT B-0%</div>  
                                        </span>
                                        <span>
                                            <div class="not-f2 font-weight-bold">TAXABLE C-0%</div> 
                                            <div class="not-f2 font-weight-bold">VAT C-0%</div>  
                                        </span>
                                        
                                        <div class="not-f3 font-weight-bold grey--text text--darken-3">TOTAL VAT</div> 
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <span class='mb-2'>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_a)}}</div>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_a)}}</div>  
                                        </span>
                                        <span class='mb-2'>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_b)}}</div> 
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_b)}}</div>  
                                        </span>
                                        <span>
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_c)}}</div> 
                                            <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_c)}}</div>  
                                        </span>
                                        <div class="not-f3 font-weight-bold grey--text text--darken-3"> {{MBS.actions.money(CalculatedVAT.total_vat)}}</div> 
                                    </v-list-item-action>   
                                </v-list-item> 
                            </div>
                            
                            <v-divider class="mx-3"></v-divider> 
                            <v-list-item     class="grey--text text--darken-3 mx- px-2" >
                                <v-list-item-content>
                                    <v-layout class="ma-0 " align-center>
                                        <div class="font-weight-bold not-f6">TOTAL PRICE:</div>
                                        <!-- <div class="pl-2 font-weight-bold not-f3">{{MBS.actions.SIZE(selected_items)}} items</div>  -->
                                    </v-layout>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-layout class="ma-0" align-center>
                                        <div class="font-weight-bold not-f3 pt-1 ">MWK </div>
                                        <div class="font-weight-bold not-f6">{{MBS.actions.money(TotalDiscountedPrice)}}</div>
                                    </v-layout> 
                                </v-list-item-action>   
                            </v-list-item>
                            <v-divider class="mx-3"></v-divider>
                        </v-list>  
                    </v-card> 
                    <v-layout v-else-if="!selected_items" fill-height align-center justify-center >
                        No Item
                    </v-layout> 
                </v-layout>  
            </v-card> 
        </v-dialog>  
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"  
    const PAGE_NAME = "SALE-ACTIONS"

    export default {
        props:['height',"click_mode","selected_items","selected_card","selected_card_option","vsh_payment_sam_table","TotalPrice","TotalDiscount","TotalDiscountedPrice","CalculatedVAT","PriceExcludeVAT","CALCULATE_PRICE","PaymentMethodsData","DisabledOnAccountFields","item_order","DataSource"],
        data(){
            return{
                show:false,   
                dialog_payment_summary:false,   
                dialog_payment_options:false,   
                input:{},   
                inputLoading:false, 
                menuPaymentOptions:false,   
                DATA:DATA,   
                 
            }
        },
        created(){ 
            try { 
                this.MBS.events.$on('ON_PAYMENT_SUMMARY', this.ON_PAYMENT_SUMMARY); 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                console.log(vs,'vs............');
                
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],

                
            }), 

             
        },
        methods:{ 
            ITEM_ACTION(action,item,option){
                this.$emit("on_item_action",action,item,option)
            },
            ADD_ITEM(item_key, item_code){
                this.$emit("on_add_item",item_key, item_code)
            },
            ON_PAYMENT_SUMMARY(value){
                this.dialog_payment_summary =! this.dialog_payment_summary
            },
            ON_PAYMENT_OPTIONS(value){
                this.dialog_payment_options =! this.dialog_payment_options
            },
            ON_PAY(){
                try {    
                    this.$emit("ON_PAY")
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_PAY',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            SELECT_PAYMENT_OPTION(payment_option){
                try {    
                    this.$emit("SELECT_PAYMENT_OPTION",payment_option)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SELECT_PAYMENT_OPTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            VERIFY_SUBMIT_ORDER(order,account){
                try {    
                    this.$emit("VERIFY_SUBMIT_ORDER",order,account)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'VERIFY_SUBMIT_ORDER',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            

            //---------------[MAIN FUNCTIONS]------------   
             

        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('ON_PAYMENT_SUMMARY', this.ON_PAYMENT_SUMMARY);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);      
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{  
            selected_items(value){
                 
            },
            CompanySettings(value){
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES()
                    this.INITIALIZE_ITEMS_DEPARTMENTS()
                }
            }, 
            selected_departments(value){
                this.ON_UPDATE_DEPARTMENT(value)
                if (value) {   
                    this.INITIALIZE_ITEMS_CATEGORIES() 
                }
            },  
        } 

    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 